import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationLogoRemovalFailedAction = {
	type: 'ORGANIZATION_LOGO_REMOVAL_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationLogoRemovalFailedAction => ({
	type: 'ORGANIZATION_LOGO_REMOVAL_FAILED',
	payload,
});
